import { getCSRF } from "../getCSRF";
import backEnd from "../../constants/backEnd";
import endpoints from "../../constants/endpoints";
import Cookies from 'js-cookie'

export async function getOpenAI(messages, config) {
  const csrf = await getCSRF();

  const sendJson = JSON.stringify({
    model: config.model,
    messages,
    temperature: config.temperature,
    max_tokens: config.max_tokens,
    top_p: config.top_p,
    frequency_penalty: config.frequency_penalty,
    presence_penalty: config.presence_penalty,
    user: `user${config.user}`
  });

  const session = Cookies.get('airton@data') && JSON.parse(Cookies.get('airton@data'));

  const response = await fetch(`${backEnd.url}${endpoints.openai.completions}`, {
    method: "POST",
    headers: {
      "Authorization": `Bearer ${session.token}`,
      "Content-Type": "application/json",
      "X-CSRFToken": csrf?.csrfToken,
      "Accept": "text/event-stream, application/json;q=0.9, /;q=0.1",
    },
    body: sendJson
  });

  const reader = response.body.getReader();
  const decoder = new TextDecoder("utf-8");

  let buffer = "";
  let fullText = "";

  while (true) {
    const { done, value } = await reader.read();
    if (done) break;

    // Decodifica o chunk e acumula no buffer
    buffer += decoder.decode(value, { stream: true });

    // Processa cada linha completa separada por "\n\n"
    const parts = buffer.split("\n\n");

    // Mantém o último pedaço incompleto no buffer
    buffer = parts.pop();

    for (const part of parts) {
      // Cada parte deve começar com "data:"
      if (part.startsWith("data: ")) {
        const jsonString = part.replace(/^data:\s*/, "").trim();

        if (jsonString === "[DONE]") continue; // ignora o final

        try {
          const data = JSON.parse(jsonString);
          if (data.type === "delta" && data.content) {
            fullText += data.content;
          }
        } catch {
          // ignora mensagens não JSON (como "stream start" ou "event: meta")
        }
      }
    }
  }
  return fullText;
}
